module.exports = __webpack_public_path__ + "media/FIVEx_tutorial_4.aac883fc.mp4";